import React, {Component} from 'react';
import Connector from './utils/api/Connector';
import Wait from '@react/react-spectrum/Wait';
import { disableLanguageSelectorToggle, isSavingToggle, setGeoPolData } from '../actions/commonActions';
import { connect } from 'react-redux';
import GovernmentPage from './pages/GovernmentPage';
import { submitButtonUpdate, submitFinal}  from './storeManagement/action';
import EducationPage from './pages/EducationPage';
import { preferredLanguageName } from '../i18n/config';
import { setLocaleWithFallback } from '../actions';
import store from '../store';
import { getGeoPolData } from '../getGeoPolDataApi';

class Specialization extends Component{ 

    constructor(props)
    {
        super(props);
        const urlParams = new URLSearchParams(window.location.search);
        this.formId = urlParams.get('type');
        this.connector = new Connector(); 
    }

    componentDidMount(){
        this.setLang('en_US');
        getGeoPolData(this.props.setGeoPolDataAction);
    }

    setLang = (lang) => {
        const finalLocale = Object.keys(preferredLanguageName).includes(lang)
                            ? preferredLanguageName[lang] : 'en_US';
        store.dispatch(setLocaleWithFallback(finalLocale));
        store.dispatch(disableLanguageSelectorToggle(true));
    }

    render(){
        let TAG = <div></div>;
        if(Object.keys(this.props.geoPolData || {}).length){
            switch(this.formId){
                case 'government':
                    TAG = <GovernmentPage 
                            onValidateChange={this.props.onValidateChange} 
                            is_saving={this.props.is_saving} 
                            connector={this.connector} 
                            onClkFinalSubmit={this.props.onClkFinalSubmit}
                            formName="Government"/>
                    break;
                case 'education':
                    TAG = <EducationPage 
                            onValidateChange={this.props.onValidateChange} 
                            is_saving={this.props.is_saving}
                            connector={this.connector}
                            onClkFinalSubmit={this.props.onClkFinalSubmit}
                            formName="Education"/>
                    break;
                default:
                    TAG = <div>URL Error : Incorrect specialization form type</div>
            }
        }

        return <div>
            {this.props.isSaving ? <div className="overlay">                              
                                    <Wait size="L" centered/>
                                    <span className="saving-Text">Saving</span>
                                    </div> : null }
           
            {TAG}
        </div>
    }
}

const mapStateToProps = (state) => ({
    isSaving : state.common.isSaving,
    geoPolData: state.common.geoPolData,
  });
  
const mapDispatchToProps = (dispatch) => ({
    onValidateChange : (bool) => dispatch(submitButtonUpdate(bool)),
    onClkFinalSubmit : (bool) => dispatch(submitFinal(bool)),
    is_saving: (e) => dispatch(isSavingToggle(e)),
    setGeoPolDataAction: (e) => dispatch(setGeoPolData(e)),
  });
  
export default connect(mapStateToProps, mapDispatchToProps)(Specialization);